import type { SalesReport } from './types';
import { formatDate, money, previousDay } from './utils';
import css from './PlanHistory.module.css';

export function ReportView({ report }: { report: SalesReport }) {
  return <>
    <h3>{report.departmentName}: {formatDate(report.dateStart)} — {formatDate(report.dateEnd)}</h3>
    <p className={css.notice}>
      {report.snapshot
        ? `Срез №${report.snapshot.id} зафиксирован ${new Date(report.snapshot.createdAt).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow' })} (МСК), сотрудник #${report.snapshot.createdBy}. Данные не изменяются.`
        : 'Период целиком не зафиксирован. Текущие данные могут изменяться; ранее закрытые месяцы внутри квартала сохраняют свой срез.'}
    </p>
    <div className={css.tableWrap}>
      <table>
        <caption>Итого за выбранный период</caption>
        <thead><tr><th>Показатель</th><th>План</th><th>Закрытый факт</th><th>К отгрузке</th></tr></thead>
        <tbody>{(['opportunity', 'profit'] as const).map(metric => <tr key={metric}>
          <th>{metric === 'opportunity' ? 'Оборот' : 'Прибыль'}</th>
          <td>{money(report[metric].target)}</td><td>{money(report[metric].value)}</td>
          <td>{money(report[metric].valuePreparation)}</td>
        </tr>)}</tbody>
      </table>
    </div>
    {report.months.map(month => <section key={month.dateStart} className={css.section}>
      <h3>{formatDate(month.dateStart)} — {formatDate(month.dateEnd)}</h3>
      <div className={css.tableWrap}>
        <table>
          <caption>Ответственность и выполнение сотрудников</caption>
          <thead><tr><th>Сотрудник</th><th>Ответственность</th><th>План оборота</th><th>Факт оборота</th><th>План прибыли</th><th>Факт прибыли</th></tr></thead>
          <tbody>{month.employees.map(employee => <tr key={employee.userId}>
            <th>{employee.name || `Сотрудник #${employee.userId}`}</th>
            <td>{employee.responsibleUntil === employee.responsibleFrom
              ? 'Передал план в начале периода'
              : `${formatDate(employee.responsibleFrom)} — ${formatDate(employee.responsibleUntil ? previousDay(employee.responsibleUntil) : month.dateEnd)} включительно`}</td>
            <td>{money(employee.opportunity.target)}</td><td>{money(employee.opportunity.value)}</td>
            <td>{money(employee.profit.target)}</td><td>{money(employee.profit.value)}</td>
          </tr>)}</tbody>
        </table>
      </div>
      {!month.employees.length && <p>Основных планов и сделок за этот месяц нет.</p>}
      {month.transfers.length > 0 && <>
        <h4>История передачи</h4>
        <ul>{month.transfers.map(transfer => <li key={transfer.id}>
          С {formatDate(transfer.effectiveDate)}: {transfer.source.name} → {transfer.toUserName}.
          {' '}Передано: оборот {money(transfer.remaining.opportunity)}, прибыль {money(transfer.remaining.profit)}.
        </li>)}</ul>
      </>}
      <details>
        <summary>Детализация сделок</summary>
        {month.employees.map(employee => <details key={employee.userId}>
          <summary>{employee.name}: {employee.deals.length} сделок</summary>
          <div className={css.tableWrap}><table>
            <caption>Сделки: {employee.name}</caption>
            <thead><tr><th>№</th><th>Клиент / ИНН</th><th>Дата</th><th>Тип</th><th>Оборот</th><th>Прибыль</th></tr></thead>
            <tbody>{employee.deals.map(deal => <tr key={`${deal.kind}:${deal.id}`}>
              <td>{deal.id}</td><td>{deal.client}<br/>{deal.inn}</td><td>{formatDate(deal.date)}</td>
              <td>{{ closed: 'Закрыта', preparation: 'К отгрузке', planned: 'Плановая' }[deal.kind]}</td>
              <td>{money(deal.opportunity)}</td><td>{money(deal.profit)}</td>
            </tr>)}</tbody>
          </table></div>
        </details>)}
      </details>
    </section>)}
  </>;
}
